import { computed } from 'vue';

import config from '@/data/config';
import store from '@/stores';

export default function useProposalSupplier() {
  const stateProposal = computed(() => store.state.proposal.proposal);
  const supplierId = computed(() => stateProposal.value.supplier_id);

  const isSupplierQiTech = computed(() => supplierId.value === config.SUPPLIER_ID_QITECH);
  const isSupplierBMP = computed(() => supplierId.value === config.SUPPLIER_ID_BMP);
  const isSupplierBMS = computed(() => supplierId.value === config.SUPPLIER_ID_BMS);
  const isSupplierCartos = computed(() => supplierId.value === config.SUPPLIER_ID_CARTOS);
  const isSupplierCelcoin = computed(() => supplierId.value === config.SUPPLIER_ID_CELCOIN);

  return {
    isSupplierQiTech,
    isSupplierBMP,
    isSupplierBMS,
    isSupplierCartos,
    isSupplierCelcoin,
  };
}
